import React, { useContext, useState } from 'react'
import "react-phone-input-2/lib/style.css"; // Import styles for react-phone-input-2
import PhoneInput from "react-phone-input-2";
import { LanguageContext } from './context/LanguageContext';

const Step1 = ({ formData, handleChange, handleNext }) => {
    const [errorMessage, setErrorMessage] = useState("");

  // Function to check if all required fields are filled
  const isFormValid = () => {
    const requiredFields = [
      "corporateName",
      "address",
      "cityStateZip",
      "emailtransactionconfirmation",
      "phone",
      "typeOfBusiness",
      "dateOfIncorporation",
      "taxIdNumber"
    ];
    return requiredFields.every((field) => formData[field] && formData[field].trim() !== "");
  };

  // Handle next button click
  const handleNextClick = () => {
    if (isFormValid()) {
      handleNext();
    } else {
      setErrorMessage("Please fill in all required fields.");
    }
  };
  const {language} = useContext(LanguageContext)
    return (
        <div>
            <h1 className="text-center text-2xl font-semibold mb-8">{language==='en'?'General Information':'Información general'}</h1>
            <div className="flex gap-3 items-center">
                <div className='w-full'>
                    <h6 className='font-medium mb-1 flex items-center gap-1 text-heading '> {language==='en'?'Corporate Name':'Nombre Corporativo'} <span className='text-red-600'>*</span></h6>
                    <input
                        type="text"
                        name="corporateName"
                        onChange={handleChange}
                        value={formData.corporateName}
                        className='border border-gray-300 rounded-md p-2 w-full mb-4 outline-none focus:border-primary'
                        required
                    />
                </div>
                <div className='w-full'>
                    <h6 className='font-medium mb-1 flex items-center gap-1 text-heading'>{language==='en'?'Trade Name of DBA (if applicable)':'Nombre Comercial'} </h6>
                    <input
                        type="text"
                        name="tradeName"
                        onChange={handleChange}
                        value={formData.tradeName || ""}
                        className='border border-gray-300 rounded-md p-2 w-full mb-4 outline-none focus:border-primary'
                    />
                </div>
            </div>
            <div className="flex gap-3 items-center">
                <div className='w-full'>
                    <h6 className='font-medium mb-1 flex items-center gap-1 text-heading'>{language==='en'?'Address (Number, Street, and Suite No.) (No PO Box)':'Dirección (número, calle y número de suite) (sin apartado postal)'} 
                        <span className='text-red-600'>*</span></h6>
                    <input
                        type="text"
                        name="address"
                        onChange={handleChange}
                        value={formData.address}
                        className='border border-gray-300 rounded-md p-2 w-full mb-4 outline-none focus:border-primary'
                        required
                    />
                </div>
                <div className='w-full'>
                    <h6 className='font-medium mb-1 flex items-center gap-1 text-heading'>{language==='en'?'City, State, and Zip Code':'Ciudad, estado y código postal'}  <span className='text-red-600'>*</span></h6>
                    <input
                        type="text"
                        name="cityStateZip"
                        onChange={handleChange}
                        value={formData.cityStateZip}
                        className='border border-gray-300 rounded-md p-2 w-full mb-4 outline-none focus:border-primary'
                        required
                    />
                </div>
            </div>
            <div className="flex gap-3 items-center">
                <div className='w-full'>
                    <h6 className='font-medium mb-1 flex items-center gap-1 text-heading'>{language==='en'?'Email (for transaction confirmations)':'Correo electrónico (para confirmaciones de transacciones)'} <span className='text-red-600'>*</span></h6>
                    <input
                        type="text"
                        name="emailtransactionconfirmation"
                        onChange={handleChange}
                        value={formData.emailtransactionconfirmation}
                        className='border border-gray-300 rounded-md p-2 w-full mb-4 outline-none focus:border-primary'
                        required
                    />
                </div>
                <div className='w-full'>
                    <div className='flex flex-col mx-16'>
                        <h6 className='font-medium mb-1 flex items-center gap-1 text-heading'>{language==='en'?'Phone':'Teléfono'}   <span className='text-red-600'>*</span></h6>
                        <PhoneInput
                            country={"us"} // Default country
                            value={formData.phone}
                            onChange={(value) =>
                                handleChange({ target: { name: "phone", value } })
                            }
                            inputClass="border border-gray-300 rounded-md p-2 w-2 mb-4 outline-none"
                            required
                        />
                    </div>
                </div>
                <div className='w-full'>
                    <h6 className='font-medium mb-1 flex items-center gap-1 text-heading'>{language==='en'?'Website':'Sitio web'} </h6>
                    <input
                        type="text"
                        name="website"
                        onChange={handleChange}
                        value={formData.website}
                        className='border border-gray-300 rounded-md p-2 w-full mb-4 outline-none focus:border-primary'
                    />
                </div>
            </div>
            <div className="flex gap-3 items-center">
                <div className='w-full'>
                    <h6 className='font-medium mb-1 flex items-center gap-1 text-heading'>{language==='en'?'Tax Identification Number':'Número de identificación fiscal'} <span className='text-red-600'>*</span></h6>
                    <input
                        type="text"
                        name="taxIdNumber"
                        onChange={handleChange}
                        value={formData.taxIdNumber}
                        className='border border-gray-300 rounded-md p-2 w-full mb-4 outline-none focus:border-primary'
                        required
                    />
                </div>
                <div className='w-full'>
                    <h6 className='font-medium mb-1 flex items-center gap-1 text-heading'>{language==='en'?'Date of Incorporation':'Fecha de Constitución'}  <span className='text-red-600'>*</span></h6>
                    <input
                        type="date"
                        name="dateOfIncorporation"
                        onChange={handleChange}
                        value={formData.dateOfIncorporation}
                        className='border border-gray-300 rounded-md p-2 w-full mb-4 outline-none focus:border-primary'
                        required
                    />
                </div>
            </div>
            <div className="flex gap-3 items-center">
                {language==='en'?(
                    <div className='w-full'>
                    <h6 className='font-medium mb-1 flex items-center gap-1 text-heading'>{language==='en'?'Type of Business (Must Select One)':'Tipo de Negocio (Debe Seleccionar Uno)'} <span className='text-red-600'>*</span></h6>
                    <div className="flex gap-4">
                    {["Individual/Sole Proprietor or Single-Member LLC ", "C Corporation", "S Corporation","Partnership","Trust/Estate", "Not Applicable"].map((method) => (
                        <label key={method} className="flex items-center space-x-2">
                            <input
                                type="radio"
                                name="typeOfBusiness"
                                value={method}
                                checked={formData.typeOfBusiness === method}
                                onChange={handleChange}
                                className="text-blue-600 focus:ring-blue-500"
                            />
                            <span>{method}</span>
                        </label>
                    ))}
                    </div>
                </div>
                ):(
                    <div className='w-full'>
                    <h6 className='font-medium mb-1 flex items-center gap-1 text-heading'>{language==='en'?'Type of Business (Must Select One)':'Tipo de Negocio (Debe Seleccionar Uno)'} <span className='text-red-600'>*</span></h6>
                    <div className="flex gap-4">
                    {["Persona Fisica ", "Anonima de Capital Variable", "Civil","Cooperative","Responsabilidad Limitada de Capital Variable", "Otra (Especifique)"].map((method) => (
                        <label key={method} className="flex items-center space-x-2">
                            <input
                                type="radio"
                                name="typeOfBusiness"
                                value={method}
                                checked={formData.typeOfBusiness === method}
                                onChange={handleChange}
                                className="text-blue-600 focus:ring-blue-500"
                            />
                            <span>{method}</span>
                        </label>
                    ))}
                    </div>
                </div>
                )}
            </div>

            <div>
            {errorMessage && (
        <p className="text-red-600 text-sm mt-4">{errorMessage}</p>
      )}

      <button
        className={`flex justify-center w-full py-2 mt-8 rounded-lg ${
          isFormValid() ? "bg-primary text-white hover:bg-primary/90" : "bg-gray-300 text-gray-500 cursor-not-allowed"
        }`}
        onClick={handleNextClick}
        disabled={!isFormValid()}
      >
        {language==='en'?'Next':'Próximo'}
      </button>
            </div>
        </div>
    )
}

export default Step1
